import { useState } from 'react';
import { SEOHead } from '../components/SEOHead';
import { GridOverlay, LevelIndicator, FocusIndicator } from '@pixcapture/shared';
import { CameraControlBar } from '../components/CameraControlBar';
import { IPhoneFrame } from '../components/IPhoneFrame';

export default function AppCameraLandscapeDemo() {
  const [gridEnabled, setGridEnabled] = useState(false);
  const [histogramEnabled, setHistogramEnabled] = useState(false);

  return (
    <>
      <SEOHead title="Kamera Landscape – pixcapture.app" description="Camera in Landscape Modus" path="/app/camera-landscape" />
      <IPhoneFrame orientation="landscape" hideStatusBar={true}>
        <div className="relative w-full h-full bg-black">
          <div className="absolute inset-0 flex items-center justify-center">
            <p className="text-white/50">Camera Landscape Mode</p>
          </div>

          {gridEnabled && <GridOverlay />}
          <LevelIndicator pitch={0} roll={0} />
          <FocusIndicator x={50} y={50} visible={true} />

          <CameraControlBar
            orientation="landscape"
            safeAreaBottom={34}
            gridEnabled={gridEnabled}
            histogramEnabled={histogramEnabled}
            onFormatClick={() => {}}
            onRoomClick={() => {}}
            onShutterClick={() => {}}
            onGridToggle={() => setGridEnabled(!gridEnabled)}
            onHistogramToggle={() => setHistogramEnabled(!histogramEnabled)}
            onSettingsClick={() => {}}
          />
        </div>
      </IPhoneFrame>
    </>
  );
}
